import { render, staticRenderFns } from "./TruckAdd.vue?vue&type=template&id=360e72ba&scoped=true"
import script from "./TruckAdd.vue?vue&type=script&lang=js"
export * from "./TruckAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360e72ba",
  null
  
)

export default component.exports